export default "/kiban/_next/static/images/purple-204f683bfdba1e3ee657da80c6168ca4.png";